import React, { useState } from 'react';
import { Card, Flex, Grid, Input, theme } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

const { useBreakpoint } = Grid;

const PageToolbar = ({
    title,
    actions,
    search,
    filters,
    children,
    bodyPadding = 16,
    style,
    cardProps = {},
    card = true,
}) => {
    const screens = useBreakpoint() || {};
    const { token = {} } = theme.useToken();
    const colorBorderSecondary = token.colorBorderSecondary || '#f0f0f0';
    const boxShadowTertiary = token.boxShadowTertiary || 'none';
    const [isSearchFocused, setIsSearchFocused] = useState(false);
    const isMobile = !!screens.xs;
    const { desktopWidth, style: searchStyle, onFocus, onBlur, ...inputProps } = search || {};
    const desktopSearchWidth = desktopWidth || 400;
    const {
        style: cardStyle,
        styles: cardStyles,
        ...restCardProps
    } = cardProps;
    const toolbar = (
        <Flex
            gap="middle"
            wrap="wrap"
            align="center"
            justify="space-between"
            style={{ width: '100%' }}
        >
            {search && (
                <Flex flex={{ xs: '100%', md: 1 }} style={{ flexGrow: 1 }}>
                    <Input
                        prefix={<SearchOutlined />}
                        {...inputProps}
                        onFocus={(event) => {
                            setIsSearchFocused(true);
                            onFocus?.(event);
                        }}
                        onBlur={(event) => {
                            setIsSearchFocused(false);
                            onBlur?.(event);
                        }}
                        style={{
                            width: isSearchFocused ? '100%' : (isMobile ? '100%' : desktopSearchWidth),
                            transition: 'width 0.25s ease-in-out',
                            ...(searchStyle || {}),
                        }}
                    />
                </Flex>
            )}

            {filters}
        </Flex>
    );

    if (!card) {
        return (
            <div style={style}>
                {(title || actions) && (
                    <Flex align="center" justify="space-between" gap="middle" style={{ marginBottom: 16 }}>
                        <div>{title}</div>
                        {actions}
                    </Flex>
                )}
                {(search || filters) && toolbar}
                {children && (
                    <div style={{ marginTop: search || filters ? 16 : 0 }}>
                        {children}
                    </div>
                )}
            </div>
        );
    }

    return (
        <Card
            title={title}
            extra={actions}
            bordered={false}
            style={{
                border: `1px solid ${colorBorderSecondary}`,
                boxShadow: boxShadowTertiary,
                ...style,
                ...(cardStyle || {}),
            }}
            styles={{
                ...(cardStyles || {}),
                body: {
                    padding: bodyPadding,
                    ...(cardStyles?.body || {}),
                },
            }}
            {...restCardProps}
        >
            {(search || filters) && toolbar}
            {children && (
                <div style={{ marginTop: search || filters ? 16 : 0 }}>
                    {children}
                </div>
            )}
        </Card>
    );
};

export default PageToolbar;
